import { render, staticRenderFns } from "./resize-controller.vue?vue&type=template&id=f72d3bda&scoped=true&"
import script from "./resize-controller.vue?vue&type=script&lang=js&"
export * from "./resize-controller.vue?vue&type=script&lang=js&"
import style0 from "./resize-controller.vue?vue&type=style&index=0&id=f72d3bda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72d3bda",
  null
  
)

export default component.exports